import { useState, useEffect } from 'react'

import StarOutline from '../assets/svgs/StarOutline'
import Star from '../assets/svgs/Star'
import Sun from '../assets/svgs/Sun'
import Moon from '../assets/svgs/Moon'

import useOnScreen from '../hooks/useOnScreen'

export default function NavBar({
	executeScroll,
	scrollElements,
	isDark,
	setIsDark,
}) {
	const { home, graphicDesign, web, contact } = scrollElements

	const [showThemeTooltip, setShowThemeTooltip] = useState(true)

	useEffect(() => {
		if (!showThemeTooltip) {
			const timeout = setTimeout(() => {
				setShowThemeTooltip(true)
			}, 1000) // Optional reset
			return () => clearTimeout(timeout)
		}
	}, [showThemeTooltip])

	const changeTheme = () => {
		setShowThemeTooltip(false)
		setIsDark(!isDark)
		if (isDark) {
			localStorage.setItem('theme', 'light')
		} else {
			localStorage.setItem('theme', 'dark')
		}
	}

	return (
		<div className='nav-btn-group'>
			<NavButton name='Home' section={home} executeScroll={executeScroll} />
			<NavButton
				name='Graphic Design'
				section={graphicDesign}
				executeScroll={executeScroll}
			/>
			<NavButton
				name='Web Development'
				section={web}
				executeScroll={executeScroll}
			/>
			<NavButton
				name='Contact'
				section={contact}
				executeScroll={executeScroll}
			/>
			<div className='pt-6 group nav-btn-container'>
				<button
					onClick={changeTheme}
					aria-label={`${!isDark ? 'Enable' : 'Disable'} dark theme`}
				>
					{!isDark ? <Sun /> : <Moon />}
					{showThemeTooltip && (
						<span className='tooltip mt-[-1.2rem]'>{`${
							!isDark ? 'Dark' : 'Light'
						} Theme`}</span>
					)}
				</button>
			</div>
		</div>
	)
}

function NavButton({ section, executeScroll, name }) {
	const [showNavTooltip, setShowNavTooltip] = useState(true)

	const handleClick = () => {
		executeScroll(section)
		setShowNavTooltip(false)
	}

	useEffect(() => {
		if (!showNavTooltip) {
			const timeout = setTimeout(() => {
				setShowNavTooltip(true)
			}, 1000) // optional: show tooltip again after 1s
			return () => clearTimeout(timeout)
		}
	}, [showNavTooltip])

	return (
		<div className='nav-btn-container group'>
			<button
				className='nav-btn'
				aria-label={`Go to ${name} page`}
				onClick={handleClick}
			>
				{useOnScreen(section) ? <Star /> : <StarOutline />}
			</button>
			{showNavTooltip && <span className='tooltip'>{name}</span>}
		</div>
	)
}
